import { useFormInput } from '@/hooks';
import { Checkbox as BaseCheckbox, Error, Group, Label } from '@/Components/UI/Form/Partials';
import { FormInputProps } from '@/types';

type InputProps = FormInputProps<HTMLInputElement>

export const Checkbox = ({
                             id,
                             name,
                             label,
                             required = false,
                             disabled = false,
                             groupClassName,
                             ...rest
                         }: InputProps) => {
    const { value, setValue, error } = useFormInput<boolean>(name);

    return (
        <Group className={groupClassName}>
            <div className={'flex items-center gap-2'}>
                <BaseCheckbox
                    {...rest}
                    id={id ?? name}
                    name={name}
                    checked={Boolean(value ?? false)}
                    onChange={(e) => setValue(Boolean(e.target.checked))}
                    invalid={error !== undefined} />

                <Label
                    htmlFor={id ?? name}
                    className={'mb-0 font-normal'}
                    required={required}
                    disabled={disabled}
                    invalid={error !== undefined}>
                    {label}
                </Label>
            </div>

            <Error error={error} />
        </Group>
    );
};
